import { render } from "./ReviewShareResultAcknowledgement.vue?vue&type=template&id=02e33f1d"
import script from "./ReviewShareResultAcknowledgement.vue?vue&type=script&lang=js"
export * from "./ReviewShareResultAcknowledgement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__